var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"buttons":['cancel'],"loading":_vm.loading,"title":`Histórico de baixa (${_vm.material.descricao})`,"large":""}},[_c('List',{ref:"List",attrs:{"material":_vm.material}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }